import * as React from 'react';
import { WithStyles, withStyles, IconButton, ImageListItemBar,} from '@material-ui/core';
import TranslateNew from "@translate/TranslateNew";
import DeleteIcon from '@material-ui/icons/DeleteForeverTwoTone';
import { IFileDesc, IStuffBeingUploaded, IFinishedUpload } from '@app-types/websocket/file.types';
import { dialogStyles } from '../DialogComponens';

const tn = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof dialogStyles>
{
    disabled? :boolean;
    serverFile?: IFileDesc;
    uploadingFile?: IStuffBeingUploaded;
    uploadedFile?: IFinishedUpload;
    removeImage: (fileId:number, removeOnServer:boolean) => void;
    zoomImage:(url:string) => void;
}

class ListImage extends React.Component<IProps> {
    public render()
    {

        const { classes, serverFile, removeImage, disabled, uploadingFile, uploadedFile } = this.props;

        const removeOnServer = serverFile === undefined;
        const showDelete = disabled && disabled === true?false:true;
        let fileUrl = ""; // TODO should be unknown file
        let filter = "unset";
        let loadProgress:string|undefined;
        let fileId = 0;
        let altName = "";

        if (serverFile !== undefined && serverFile.url !== undefined) {
          fileUrl = serverFile.url;
          fileId = serverFile.id?serverFile.id:0;
          altName = serverFile.fileName;
        } else if (uploadedFile !== undefined && uploadedFile.localURL !== undefined) {
          fileUrl = uploadedFile.localURL;
          fileId = uploadedFile.id;
          altName = uploadedFile.fileName;
        } else if (uploadingFile !== undefined && uploadingFile.localURL !== undefined) {
          fileUrl = uploadingFile.localURL;
          filter = "blur(4px)";
          loadProgress = uploadingFile.loaded + "%";
          fileId = uploadingFile.id;
          altName = uploadingFile.fileName;
        }

        return (
            <div style={{ minWidth: '29%', maxWidth: '29%', height: '104px', padding: '2px', position:'relative'}} >
                <img src={fileUrl} alt={altName} style={{filter, maxWidth:'100%', maxHeight:'98px'}} onClick={() => this.props.zoomImage(fileUrl)}/>
                {loadProgress && <ImageListItemBar title={loadProgress}/>}
                {showDelete && <IconButton className={classes.smallDeleteButton} onClick={() => removeImage(fileId,removeOnServer)}>
                  <DeleteIcon style={{fill:"#f65a55", fontSize:'18px'}} />
                </IconButton>}
            </div>
        );
    }
}

export default withStyles(dialogStyles)(ListImage);



// WEBPACK FOOTER //
// ./src/components/economy/sharedcomponents/ListImage.tsx